import React, { FC, useEffect, useState } from 'react'
import { DatasetRule, DatasetRuleType } from 'tabs/data/api/generated'
import * as S from '../DatasetMetrics/MetricsForm/MetricsForm.style'
import { CSelect } from 'tabs/data/components/CSelect'
import { Option } from 'helpers/selects'
import { MAX_TEXT_LENGTH } from 'tabs/data/constants'
import { CButton } from 'tabs/data/components/CButton'

const ruleTypeOptions: Option[] = [
  {
    label: 'During writing response or the data Inquiry',
    value: DatasetRuleType.DataInqueryResponseWritingRule,
  },
  {
    label: 'During writing of the dax query',
    value: DatasetRuleType.DaxQueryWritingRule,
  },
]

type DatasetRuleProps = {
  index: number
  disabled?: boolean
  data: DatasetRule
  onChange: (rule: string, type: DatasetRule['type']) => void
  onDelete: (index: number) => void
}

export const DatasetRuleItem: FC<DatasetRuleProps> = ({ index, disabled, data, onChange, onDelete }) => {
  const [text, setText] = useState(data.rule || '')
  const [type, setType] = useState(data.type || '')

  const validatePrompt = (value = ''): string => {
    if (value.length > MAX_TEXT_LENGTH) {
      return `You've reached the max length for the text value — ${MAX_TEXT_LENGTH} characters`
    } else if (!value.trim().length) {
      return "The field can't be empty."
    }
    return ''
  }

  const handleRuleChange = e => {
    const { value } = e.target

    setText(value)
  }

  const errorType = validatePrompt(text)
  const errorPrompt = validatePrompt(text)

  useEffect(() => {
    onChange(text, type as DatasetRule['type'])
  }, [text, type])

  return (
    <div style={{ width: '100%', display: 'grid', gap: '0.5rem', marginBottom: '1rem' }}>
      <S.Title>
        {1 + index}. Rule{' '}
        {/*{canBeSaved && <small style={{ color: 'var(--color-text-error)' }}>(Both fields are required)</small>}*/}
        <CButton
          disabled={disabled}
          variant="outlined"
          color="danger"
          label="Delete"
          style={{ marginLeft: '0.5rem', height: '32px' }}
          onClick={() => onDelete(index)}>
          Delete
          {/*<TrashIcon color="var(--color-spun-pearl-grey)" />*/}
        </CButton>
      </S.Title>
      <S.Title>Execution context*</S.Title>
      <CSelect
        placeholder="Select execution context"
        disabled={disabled}
        options={ruleTypeOptions}
        value={type}
        onChange={setType}
      />
      <S.Error>{errorType}</S.Error>

      <S.Title>Prompt*</S.Title>
      {/*<S.InputContainer isError={Boolean(errorPrompt)}>*/}
      <S.InputContainer>
        <S.Textarea
          disabled={disabled}
          placeholder="+ Insert text here"
          value={text}
          onChange={handleRuleChange}
          // isError={Boolean(errorPrompt)}
        />
      </S.InputContainer>
      <S.Error>{errorPrompt}</S.Error>
    </div>
  )
}
